import { Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateModule } from '@ngx-translate/core'
import { LocalStorage } from 'ngx-store'

import { ClickBlockingDirective } from 'common/util'

export interface SequenceRenderParams {
  name: string
  presetName: string
}

@Component({
  selector: 'resolve-render-sequence-modal',
  templateUrl: './resolveRenderSequenceModal.component.html',
  imports: [
    FormsModule,
    TranslateModule,
    ClickBlockingDirective,
  ],
})
export class ResolveRenderModalComponent {
  @LocalStorage('resolveProSequenceRenderName') name = 'Sequence'
  @LocalStorage('resolveProSequenceRenderPreset') presetName = ''

  @Input() presets: string[] = []

  constructor (
    private modalInstance: NgbActiveModal,
  ) { }

  ngOnInit () {
    this.presetName = this.presetName || this.presets[0]!
  }

  render = async () => {
    this.modalInstance.close({
      name: this.name,
      presetName: this.presetName,
    })
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
